export default __webpack_public_path__ + "static/media/chart_video.720f6773.webm";